module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nationalDay"
  }, [_c('x-header', [_vm._v("患者检验信息")]), _vm._v(" "), _c('div', {
    staticClass: "page-loadmore"
  }, [_c('div', {
    staticClass: "page-loadmore-wrapper"
  }, [_c('mt-loadmore', {
    ref: "loadmore",
    attrs: {
      "bottom-method": _vm.loadBottom,
      "bottom-all-loaded": _vm.allLoaded
    },
    on: {
      "bottom-status-change": _vm.handleBottomChange
    }
  }, [_c('ul', {
    staticClass: "page-loadmore-list"
  }, [_c('x-table', {
    staticStyle: {
      "background-color": "#fff"
    },
    attrs: {
      "cell-bordered": false,
      "content-bordered": false
    }
  }, [_c('thead', [_c('tr', {
    staticStyle: {
      "background-color": "#F7F7F7"
    }
  }, [_c('th', [_vm._v("项目名称")]), _vm._v(" "), _c('th', [_vm._v("检验值")]), _vm._v(" "), _c('th', [_vm._v("高低")]), _vm._v(" "), _c('th', [_vm._v("参考值")]), _vm._v(" "), _c('th', [_vm._v("检验日期")])])]), _vm._v(" "), _c('tbody', _vm._l((this.resultOption), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(item.itemName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.inspecValue))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(item.highLow))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.highLowGap))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(item.doCheckTime))])])
  }))]), _vm._v(" "), _c('load-more', {
    attrs: {
      "show-loading": _vm.loadmoreShow,
      "tip": _vm.loadmoreTxt,
      "background-color": "#fbf9fe"
    }
  })], 1)])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2eaf36ec","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/project/prescnoVerifyProject/patientlabinfo.vue
// module id = 0jZA
// module chunks = 6